import { useState } from "react";
import { useCreateStripeAdminAxiosInstance } from "../../../Auth/useCreateStripeAdminAxiosInstance.ts";
import { StripeOrderDTO } from "../../../Stripe/StripeOrderDTO.ts";
import { SettleInstallmentsRequest } from "./InstallmentsSettlementDTO.ts";

export function useSettleInstallmentsByBankTransfer() {
  const { createAxiosInstance } = useCreateStripeAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const settleInstallments = async (
    orderId: string,
    request: SettleInstallmentsRequest,
  ): Promise<StripeOrderDTO> => {
    try {
      setLoading(true);
      const { data } = await createAxiosInstance().post<StripeOrderDTO>(
        `/admin/orders/${orderId}/installments-settlement`,
        request,
      );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return { settleInstallments, loading };
}
